// @ts-check

import React from 'react';
import Avatar from '@mui/material/Avatar';
import { object } from 'prop-types';

/**
 * @component AvatarBadge
 * @param {Object} props
 * @param {Object} props.user
 * @param {string} props.user.id
 * @param {string} props.user.contactId
 * @param {string} props.user.customerId
 * @param {string} props.user.username
 * @param {string} props.user.strAva
 * @param {string} props.user.vFile
 * @param {string} props.user.img
 * @return {JSX.Element}
 */
function AvatarBadge({ user }) {
	return (
		<Avatar sx={{ width: '2.25rem', height: '2.25rem' }} src={user.img}>
			<span style={{ fontSize: '0.9rem' }}>{user.strAva}</span>
		</Avatar>
	);
}

AvatarBadge.propTypes = { user: object };

export default AvatarBadge;
